import { render, staticRenderFns } from "./CreateCompany.yaml?vue&type=template&id=14a4c0f2&component"
import script from "./CreateCompany.yaml?vue&type=script&lang=ts&component"
export * from "./CreateCompany.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports